import React, { useState, useCallback, useEffect } from 'react'
import NeoButton from '../../../components/NeoButton/NeoButton'
import { useHistory } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import Modal from '../../../components/Modal/Modal'
import { useModal } from 'react-modal-hook'
import P_ViewBillerIcon from 'custom/assets/payments/ViewBiller.svg'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import PaymentsService from '../../../services/payments.service'
import LayoutWithOutAccountCard from '../../Layout/layout-without-card'
import NotificationService from '../../../services/notification.service'
import { BUTTON_KEYS, VIEW_BILLER_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

const SERVICE_LABELS = {
  Topstar: 'Meter Number',
  Airtel_Topup: 'Mobile Number',
  Zamtel_Topup: 'Mobile Number',
  MTN_Topup: 'Mobile Number',
  Zesco: 'Meter Number',
  GOtv: 'IUC Number',
  DStv: 'Smart Card Number',
  LiquidTelecom_Data: 'Account Number',
  MTN_Data: 'Account Number',
  Vodafone: 'Account Number',
  MLife: 'Account Number',
  Afribus: 'Service Number',
  ZRA: 'PRN',
}

export default function BillerBeneList() {
  const history = useHistory()
  const [noRecords, setNoRecords] = useState(false)
  const [billerBeneList, setBillerBeneList] = useState([])
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const [error, setError] = useState({})
  const [selectedBiller, setSelectedBiller] = useState({})
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  const [showDeleteBeneModal, hideDeleteBeneModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{t(VIEW_BILLER_KEYS.DELETE_MESSAGE)}</h6>
          <div className='row' style={{ marginTop: 30 }}>
            <div className='form-group col-6'>
              {deleteLoading ? (
                <NeoLoader />
              ) : (
                <NeoButton
                  tabIndex='1'
                  type='button'
                  text={t(BUTTON_KEYS.CONFIRM)}
                  mode='newDesign'
                  onClick={() => deleteBillerBeneficiary()}
                />
              )}
            </div>
            <div className='form-group col-6' style={{ display: 'flex' }}>
              <div
                tabIndex={'2'}
                className='back-cancel-style'
                style={{ marginTop: 15 }}
                onClick={() => hideDeleteBeneModal()}>
                {t(BUTTON_KEYS.CANCEL)}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    ),
    [deleteLoading, selectedBiller],
  )

  const deleteBillerBeneficiary = useCallback(async () => {
    try {
      setDeleteLoading(true)
      const response = await PaymentsService.deleteBillerBeneficiary({
        serviceId: selectedBiller.serviceId,
        serviceNumber: selectedBiller.serviceNumber,
        shortName: selectedBiller.shortName,
        merchant: selectedBiller.merchant,
        beneId: selectedBiller.beneId,
      })
      if (response.status === 200) {
        setDeleteLoading(false)
        hideDeleteBeneModal()
        setBillerBeneList([])
        NotificationService.showSuccessMessage(response.data['message'])
        // setMessage(response.data['message'])
        fetchBillerBeneficiaries()
      }
    } catch (err) {
      hideDeleteBeneModal()
      setDeleteLoading(false)
      setError(err)
      // //showModal()
    }
  }, [selectedBiller])

  const handleDeleteBene = useCallback(async (selected) => {
    await setSelectedBiller(selected)
    showDeleteBeneModal()
  }, [])

  const fetchBillerBeneficiaries = useCallback(async () => {
    try {
      setLoading(true)
      const response = await PaymentsService.getBillerBeneficiaries({
        merchant: '',
        serviceId: '',
        serviceNumber: '',
        shortName: '',
      })
      if (response.status === 200) {
        response.data['billerBeneficiary'].forEach((element) => {
          element.isActive = false
        })
        setBillerBeneList(response.data['billerBeneficiary'])
        setNoRecords(response.data['billerBeneficiary'].length === 0 ? true : false)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      // setError(err)
      // //showModal()
    }
  }, [])
  useEffect(() => {
    fetchBillerBeneficiaries()
  }, [])

  return (
    <LayoutWithOutAccountCard
      breadCumKey='VIEW_BILLER'
      showEmptySpace={true}
      keyPath={'VIEW_BILLER'}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style'>{t(VIEW_BILLER_KEYS.TITLE)}</div>
        </div>
      </div>

      {loading && <NeoLoader />}

      <div className='row'>
        {billerBeneList.map((option, i) => (
          <div key={i} className='col-6'>
            <div className='deposit-menu-card'>
              <div className='deposit-header'>
                <label>{t(VIEW_BILLER_KEYS.SHORT_NAME)}</label>
                <p>{option?.shortName || '-'}</p>
              </div>
              <div className='deposit-header'>
                <label>{t(VIEW_BILLER_KEYS.MERCHANT)}</label>
                <p>{option?.merchant || '-'}</p>
              </div>
              <div className='deposit-header'>
                <label>{t(VIEW_BILLER_KEYS.SERVICE_NO)}</label>
                <p>{option?.serviceNumber || '-'}</p>
              </div>

              <div className='back-cancel-btn-container'>
              <button tabIndex={`${i+1}`} className='back-cancel-btn btn btn-sm new-design-warning-text-color'  onClick={() => handleDeleteBene(option)}>
                {t(BUTTON_KEYS.DELETE)}
              </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {noRecords && <div className='no-data-found'>{t(VIEW_BILLER_KEYS.NO_RECORDS)}</div>}
    </LayoutWithOutAccountCard>
  )
}
